import { isEmpty } from 'lodash/fp';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useListWebCalcSettingsQuery } from '../../../../api/queries/listWebCalcSettings';

const useWebCalcSettingOptions = (moduleId: string | null | undefined) => {
    const { data } = useListWebCalcSettingsQuery({
        fetchPolicy: 'cache-and-network',
        variables: { moduleId },
        skip: isEmpty(moduleId),
    });
    const { t } = useTranslation('common');

    return useMemo(() => {
        const options = data?.result?.items?.map(({ id, displayName }) => ({ label: displayName, value: id })) ?? [];

        options.push({ label: t('common:none'), value: null });

        return options;
    }, [data?.result?.items, t]);
};

export default useWebCalcSettingOptions;
